import React from 'react';
import NumberFormat from 'react-number-format';
import LinkIcon from '@material-ui/icons/Link';
import { ReservationDetailsUiModel } from '../../../../../shared/ui-models/reservation.ui-model';

export interface ChannelManagerInfoCardProps {
  data: {
    reservation: ReservationDetailsUiModel;
  };
}

interface InfoFieldProps {
  label: string;
  value: React.ReactNode;
}

const InfoField = ({ label, value }: InfoFieldProps) => (
  <div className="flex flex-col gap-1">
    <span className="mb-2 font-gilroy-medium text-neutral-500 font-medium text-xl uppercase ">
      {label}
    </span>
    <span className="font-gilroy-bold text-xl text-primary-600">{value}</span>
  </div>
);

export const ChannelManagerInfoCard = ({ data: { reservation } }: ChannelManagerInfoCardProps) => {
  if (
    !(
      reservation.channel ||
      reservation.channelCommission ||
      (reservation?.paymentList && reservation.paymentList?.length > 0)
    )
  )
    return null;

  const paymentList = reservation.paymentList ?? [];
  const currency =
    paymentList.length > 0 && paymentList[0].currency
      ? paymentList[0].currency.toUpperCase()
      : 'EGP';

  return (
    <div className="bg-white rounded-lg shadow-sm bg-gradient-to-b from-primary-50/60 to-white  p-5">
      {/* Card header */}
      <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-100">
        <h3 className="text-xl font-gilroy-bold font-semibold text-gray-700 leading-tight">
          Channel Manager Info
        </h3>
        <p className="text-sm text-primary-500 font-bold leading-tight">via Rentals United</p>
      </div>

      {/* Fields grid */}
      <div className="grid grid-cols-2 gap-4">
        <InfoField
          label="Channel"
          value={reservation.channel ? reservation.channel.toUpperCase() : '—'}
        />
        <InfoField label="Currency" value={currency} />
        {reservation.channelCommission?.amount && (
          <InfoField
            label="Channel Commission"
            value={
              <NumberFormat
                value={reservation.channelCommission.amount}
                displayType="text"
                thousandSeparator
                prefix={`${reservation.channelCommission.currency || 'EGP'} `}
              />
            }
          />
        )}
      </div>
    </div>
  );
};
